"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.flat-map");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.from");

require("core-js/modules/es.array.includes");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.join");

require("core-js/modules/es.array.map");

require("core-js/modules/es.array.reduce");

require("core-js/modules/es.array.slice");

require("core-js/modules/es.array.unscopables.flat-map");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.includes");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.string.starts-with");

require("core-js/modules/web.dom-collections.for-each");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComponentByPathValueSource = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _Number = require("./Number");

var _SameIndex = require("./SameIndex");

var _ValueSource2 = require("./ValueSource");

var _Variable = require("./Variable");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var indexTypes = [_Number.NumberValueSource, _SameIndex.SameIndexValueSource, _Variable.VariableValueSource].reduce(function (result, indexType) {
  return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, indexType.name, indexType));
}, {});
var commonIndexSources = [_Number.NumberValueSource, _Variable.VariableValueSource];

var ComponentByPathValueSource = /*#__PURE__*/function (_ValueSource) {
  _inherits(ComponentByPathValueSource, _ValueSource);

  var _super = _createSuper(ComponentByPathValueSource);

  function ComponentByPathValueSource() {
    _classCallCheck(this, ComponentByPathValueSource);

    return _super.apply(this, arguments);
  }

  _createClass(ComponentByPathValueSource, [{
    key: "getValue",
    value: function getValue(input) {
      var _this = this;

      var pathForRowIndex;
      var lastIndex = null;
      var component = input.reduce(function (context, pathPart) {
        if (_lodash.default.isNil(context)) {
          return context;
        }

        var component = pathPart.component,
            indexType = pathPart.indexType,
            indexInput = pathPart["".concat(indexType, "Index")];

        var lastIndexExists = _lodash.default.isNumber(lastIndex);

        var getNextContext = function getNextContext(prevContext) {
          var nextContext = prevContext.getComponent(component);
          return lastIndexExists && _lodash.default.isArray(nextContext) ? nextContext[lastIndex] : nextContext;
        };

        var nextContext = Array.isArray(context) ? context.flatMap(function (contextElement) {
          return getNextContext(contextElement);
        }) : getNextContext(context);
        pathForRowIndex = "".concat(pathForRowIndex ? "".concat(pathForRowIndex).concat(lastIndexExists ? "[".concat(lastIndex, "]") : '', ".") : '').concat(component);

        if (lastIndexExists) {
          lastIndex = null;
        }

        if (indexType) {
          var IndexType = indexTypes[indexType];

          if (!IndexType) {
            return null;
          }

          var indexTypeInstance = new IndexType(_objectSpread(_objectSpread({}, _this.context), {}, {
            options: _objectSpread(_objectSpread({}, _this.options), {}, {
              pathForRowIndex: pathForRowIndex
            })
          }));
          lastIndex = indexTypeInstance.getValue(indexInput);
        }

        return nextContext;
      }, this.formInstance);
      return component !== null && component !== void 0 ? component : null;
    }
  }], [{
    key: "getInputEditForm",
    value: function getInputEditForm(options) {
      return {
        label: 'Component Path',
        inlineEdit: true,
        type: 'editgrid',
        input: true,
        templates: {
          header: "<div class=\"row\">\n            <div class=\"col-sm-10\">Path Part</div>\n            <div class=\"col-sm-2\"></div>\n          </div>",
          row: function row(_ref) {
            var flattenedComponents = _ref.flattenedComponents,
                row = _ref.row;
            var componentKey = flattenedComponents.component.getView(row.component);
            var inputName = "".concat(row.indexType, "Index");
            var index = row.indexType === 'same' ? 'Same Index' : flattenedComponents[inputName] ? flattenedComponents[inputName].getView(row[inputName]) : '';
            var path = "".concat(componentKey).concat(index ? " [".concat(index, "]") : '');
            return "<div class=\"row\">\n              <div class=\"col-sm-10\">".concat(path, "</div>\n              <div class=\"col-sm-2\">\n                <button class=\"btn btn-default btn-light btn-sm editRow\">E</button>\n                <button class=\"btn btn-danger btn-sm removeRow\">D</button>\n              </div>\n            </div>");
          }
        },
        addAnother: 'Add Path Part',
        saveRow: 'Save Path Part',
        components: [{
          label: 'Component',
          dataSrc: 'custom',
          data: {
            custom: function custom(_ref2) {
              var instance = _ref2.instance,
                  rowIndex = _ref2.rowIndex;
              var pathComponentsMapping = instance.root.pathComponentsMapping;
              var path = instance.parent.dataValue;
              var currentPath = path.slice(0, rowIndex).map(function (_ref3) {
                var component = _ref3.component;
                return component;
              }).join('.'); // const contextRow = {
              //   label: 'Context',
              //   value: '[context]',
              // };

              return pathComponentsMapping[currentPath];
            }
          },
          valueProperty: 'key',
          dataType: 'string',
          template: '<span>{{ item.label || item.key }} ({{ item.key }})</span>',
          validate: {
            required: true // custom({ instance, rowIndex, row }) {
            //   const { pathComponentsMapping } = instance.root;
            //   const path = instance.parent.dataValue;
            //   const currentPath = path.slice(0, rowIndex).map(({ component }) => component).join('.');
            //   const currentPathPart = row.component;
            //   const components = pathComponentsMapping[currentPath];
            //   const componentsExists = Boolean(components);
            //   const valid = !componentsExists || components.some(({ key }) => key === currentPathPart);
            //   return valid ? true : 'Path doesn\'t exist';
            // },

          },
          key: 'component',
          type: 'select',
          input: true
        }, {
          label: 'Index',
          dataSrc: 'custom',
          data: {
            custom: function custom(_ref4) {
              var instance = _ref4.instance,
                  rowIndex = _ref4.rowIndex;
              var parentPath = instance.root.parentPath;
              var path = instance.parent.dataValue;
              var currentPath = path.slice(0, rowIndex + 1).map(function (_ref5) {
                var component = _ref5.component;
                return component;
              }).join('.');
              var inSameScope = parentPath.startsWith("".concat(currentPath, ".")) || parentPath === currentPath;
              var commonOptions = commonIndexSources.map(function (indexSource) {
                return {
                  label: indexSource.title,
                  value: indexSource.name
                };
              });
              return (inSameScope ? [{
                label: _SameIndex.SameIndexValueSource.title,
                value: _SameIndex.SameIndexValueSource.name
              }] : []).concat(commonOptions);
            }
          },
          valueProperty: 'value',
          dataType: 'string',
          key: 'indexType',
          customConditional: function customConditional(_ref6) {
            var instance = _ref6.instance,
                rowIndex = _ref6.rowIndex;
            var arrayDataComponentPaths = instance.root.arrayDataComponentPaths;
            var path = instance.parent.dataValue;
            var currentPath = path.slice(0, rowIndex + 1).map(function (_ref7) {
              var component = _ref7.component;
              return component;
            }).join('.');
            return arrayDataComponentPaths.includes(currentPath);
          },
          type: 'select',
          input: true
        }].concat(_toConsumableArray(commonIndexSources.map(function (indexSource) {
          return _objectSpread(_objectSpread({}, indexSource.getInputEditForm(options)), {}, {
            key: "".concat(indexSource.name, "Index"),
            conditional: {
              json: {
                '===': [{
                  var: 'row.indexType'
                }, indexSource.name]
              }
            }
          });
        }))),
        conditionalAddButton: function conditionalAddButton(_ref8) {
          var value = _ref8.value,
              instance = _ref8.instance;
          var pathComponentsMapping = instance.root.pathComponentsMapping;
          var currentPath = value.map(function (_ref9) {
            var component = _ref9.component;
            return component;
          }).join('.');
          return Boolean(pathComponentsMapping[currentPath]);
        }
      };
    }
  }, {
    key: "name",
    get: function get() {
      return 'componentPath';
    }
  }, {
    key: "title",
    get: function get() {
      return 'Component By Path';
    }
  }, {
    key: "weight",
    get: function get() {
      return 100;
    }
  }]);

  return ComponentByPathValueSource;
}(_ValueSource2.ValueSource);

exports.ComponentByPathValueSource = ComponentByPathValueSource;